const variableStyles = {
  // Primary color
  primaryBasic: '#000000',
  primaryBasic9: 'rgba(0, 0, 0, 0.9)',
  primaryBasic8: 'rgba(0, 0, 0, 0.8)',
  primaryBasic7: 'rgba(0, 0, 0, 0.7)',
  primaryBasic6: 'rgba(0, 0, 0, 0.6)',
  primaryBasic5: 'rgba(0, 0, 0, 0.5)',
  primaryBasic4: 'rgba(0, 0, 0, 0.4)',
  primaryBasic3: 'rgba(0, 0, 0, 0.3)',
  primaryBasic2: 'rgba(0, 0, 0, 0.2)',
  primaryBasic1: 'rgba(0, 0, 0, 0.1)',

  // Secondary color
  secondaryBlueBasic: '#1428A0',
  secondaryBlueLight: '#0071C5',

  // Background color
  backgroundBasic: '#FFFFFF',
  backgroundBasic9: 'rgba(255, 255, 255, 0.9)',
  backgroundBasic8: 'rgba(255, 255, 255, 0.8)',
  backgroundBasic7: 'rgba(255, 255, 255, 0.7)',
  backgroundBasic6: 'rgba(255, 255, 255, 0.6)',
  backgroundBasic5: 'rgba(255, 255, 255, 0.5)',
  backgroundBasic4: 'rgba(255, 255, 255, 0.4)',
  backgroundBasic3: 'rgba(255, 255, 255, 0.3)',
  backgroundBasic2: 'rgba(255, 255, 255, 0.2)',
  backgroundBasic1: 'rgba(255, 255, 255, 0.1)',

  // Semantic color palette
  semanticError: '#EA1A59',
  semanticSuccess: '#00A76B',
  semanticWarning: '#F3B02E',

  // + Icon color:
  iconDefault: '#9A9DB2',
  iconActive: '#3D63DC',
  iconHover: '#6E7391',
  iconDisabled: '#C4C8D6',
  iconSuccess: '#36C171',
  iconWarning: '#F5BF3B',
  iconError: '#ED433E',
  iconInformation: '#009FDA',

  // + Surface color:
  surfaceWhite: '#FFFFFF',
  surfaceGray: '#F9F9FC',
  surfaceSky: '#ECF2FD',
  surfaceSuccess: '#EBFFF3',
  surfaceWarning: '#FCF6E6',
  surfaceError: '#FEEAEA',
  surfaceInformation: '#C9EFFC',
  surfaceDisabled: '#EEEEF7',
  surfaceSelected: '#3D63DC',

  //Other
  textSecondary: '#555970',
  primaryWhite: '#ffffff',

  // Font Size
  fs12: '12px',
  fs14: '14px',
  fs16: '16px',
  fs18: '18px',
  fs20: '20px',
  fs22: '22px',
  fs24: '24px',
  fs25: '25px',
  fs28: '28px',
  fs30: '30px',
  fs36: '36px',

  // Font Weight
  fwNormal: 'normal',
  fwLight: 300,
  fwRegular: 400,
  fwSemiBold: 500,
  fwBold: 600,

  // Line height
  lh0: 'normal',
  lh14: '14px',
  lh16: '16px',
  lh17: '17px',
  lh18: '18px',
  lh19: '19px',
  lh20: '20px',
  lh22: '22px',
  lh24: '24px',
  lh26: '26px',
  lh28: '28px',
  lh30: '30px',
  lh32: '32px',
  lh33: '33px',
  lh36: '36px',
  lh40: '40px',
  lh54: '54px',

  // Letter spacing
  letterSpacing_0: '0.0015em',
  letterSpacing_1: '0.0025em',
  letterSpacing_2: '0.004em',
  letterSpacing_3: '0.0125em',

  // table row height
  TABLE_ROW_HEIGHT: 48,
};

export default variableStyles;
